import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {routing} from "./auth.routing";
import {AuthComponent} from "./auth.component";
import { RegisterComponent } from './register/register.component';
import {Ng2Webstorage} from 'ngx-webstorage';
import { ActivationLinkComponent } from './login/activation-link/activation-link.component';
import { AdminActivationComponent } from './login/admin-activation/admin-activation.component';
import { SharedModule } from '../common/shared.module';

@NgModule({
  imports: [
    CommonModule,
    routing,
    Ng2Webstorage,
    SharedModule
  ],
  declarations: [AuthComponent,AdminActivationComponent]
})
export class AuthModule { }



// WEBPACK FOOTER //
// /Users/ldt/Desktop/afropay_admin/afropay-admin-frontend/src/app/auth/auth.module.ts